import * as api from './api'
import { THREE_MINUTES } from '@/constants/time'
import { checkTtlDate } from '@/helper'

export default {
  async loadData ({ commit, state }, { force = false } = {}) {
    const isNeedUpdate = checkTtlDate({
      timeUpdate: state.lastDateUpdated,
      ttlTime: THREE_MINUTES
    })

    if (!force && state.data.length && !isNeedUpdate) {
      return { data: state.data }
    }

    const { data } = await api.loadData() || {}

    if (data?.code === 200) {
      commit('setData', data.data)
      commit('setLastDateUpdated')

      return { data: data.data }
    }

    return { error: data.data }
  },
  async loadLastBalance () {
    const { data } = await api.loadLastBalance() || {}

    if (data?.code === 200) {
      return { data: data.data }
    }

    return { error: data.data }
  },
  async create ({ commit, state }, payload) {
    const { data } = await api.create(payload) || {}

    if (data?.code === 200) {
      const newData = state.data

      newData.unshift(data.data)
      commit('setData', newData)

      return { data: data.data }
    }

    return { error: data.data }
  },
  async change ({ commit, state }, { id, data: payloadData } = {}) {
    const { data } = await api.change(id, payloadData)

    if (data?.code === 200) {
      const newData = state.data.map(item => {
        if (item.id === id) {
          item = {
            ...item,
            ...payloadData
          }
        }

        return item
      })

      commit('setData', newData)

      return { data: data.data }
    }

    return { error: data.data }
  },
  async remove ({ commit, state }, payload) {
    const { data } = await api.remove(payload) || {}

    if (data?.code === 200) {
      const newData = state.data.filter(({ id }) => id !== payload )

      commit('setData', newData)

      return { data: data.data }
    }

    return { error: data.data }
  }
}